import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  reportHeading: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(1),
  },
  reportList: {
    listStyle: 'none',
    padding: 0,
    margin: theme.spacing(1, 0),
    border: `1px solid ${theme.palette.common.gray300}`,
    borderRadius: theme.shape.borderRadius,
  },
  reportItem: {
    padding: theme.spacing(1, 2),
    '& + &': { borderTop: `1px solid ${theme.palette.common.gray300}` },
  },
  reportRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  reportName: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  reportEditor: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  reportFields: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: 'minmax(0, 1fr)' },
  },
  fieldLabel: {
    color: theme.palette.common.gray800,
    marginBottom: theme.spacing(1),
  },
  fieldGroup: {
    marginBottom: theme.spacing(2),
  },
  metadataErrorNotice: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  matchingHelperText: {
    color: theme.palette.common.gray600,
    marginBottom: theme.spacing(1),
  },
  ssnSource: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  ssnSourceHelperText: {
    color: theme.palette.common.gray600,
    display: 'block',
    marginTop: theme.spacing(1),
  },
  radioOptionsContainer: {
    marginLeft: theme.spacing(2),
  },
  radioLabel: {
    marginBottom: theme.spacing(1),
  },
  shadowModeContainer: {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(2),
  },
  shadowModeHelperText: {
    color: theme.palette.common.gray600,
    marginLeft: theme.spacing(1),
  },
  enrichmentSuggestions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  alwaysCopiedBlock: {
    marginBottom: theme.spacing(2),
  },
  alwaysCopiedItem: {
    alignItems: 'baseline',
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  alwaysCopiedKey: {
    color: theme.palette.common.gray600,
    flexShrink: 0,
    fontFamily: 'monospace',
    userSelect: 'text',
  },
  enrichmentWarning: {
    marginBottom: theme.spacing(2),
    '& > div': {
      margin: 'initial',
    },
  },
  optionalEnrichmentHeader: {
    alignItems: 'baseline',
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  optionalEnrichmentLimit: {
    color: theme.palette.common.gray600,
  },
  enrichmentLimitNotice: {
    color: theme.palette.common.gray600,
    display: 'block',
    marginBottom: theme.spacing(2),
  },
  enrichmentRow: {
    alignItems: 'flex-start',
    display: 'grid',
    gap: theme.spacing(1),
    gridTemplateColumns: 'minmax(120px, 1fr) auto minmax(160px, 1fr) auto',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr auto',
    },
  },
  enrichmentSource: {
    paddingTop: theme.spacing(1),
  },
  enrichmentArrow: {
    color: theme.palette.common.gray600,
    paddingTop: theme.spacing(1),
  },
  enrichmentTarget: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: '1 / -1',
    },
  },
  enrichmentRemove: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: 2,
      gridRow: 1,
    },
  },
  subCard: {
    border: `1px dashed ${theme.palette.common.gray400}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
  },
  subCardTitle: {
    color: theme.palette.common.gray800,
    marginBottom: theme.spacing(1),
  },
  subCardDescription: {
    color: theme.palette.common.gray600,
    marginBottom: theme.spacing(2),
  },
  dryRunFieldsRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  dryRunButtonContainer: {
    marginTop: theme.spacing(2),
  },
  dryRunResult: {
    marginTop: theme.spacing(2),
  },
  verdictPill: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  verdictPillEligible: {
    backgroundColor: theme.palette.common.green100,
    color: theme.palette.common.green800,
  },
  verdictPillNotEligible: {
    backgroundColor: theme.palette.common.red100,
    color: theme.palette.common.red800,
  },
  verdictPillNeutral: {
    backgroundColor: theme.palette.common.gray200,
    color: theme.palette.common.gray800,
  },
  verdictPillWarning: {
    backgroundColor: theme.palette.common.orange100,
    color: theme.palette.common.orange800,
  },
  resultDetailRow: {
    color: theme.palette.common.gray800,
  },
  resultDetailLabel: {
    color: theme.palette.common.gray600,
  },
}));
